var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16770)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.396 0.333313H13.6292C14.9384 0.333313 15.9998 1.38544 15.9998 2.68331V13.65C15.9998 14.9478 14.9384 16 13.6292 16H11.396V0.333313Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12346 0.333313H10.6059C11.9152 0.333313 12.9765 1.38544 12.9765 2.68331V13.65C12.9765 14.9478 11.9152 16 10.6059 16H1.12346C0.687039 16 0.333252 15.6493 0.333252 15.2166V1.11665C0.333252 0.684023 0.687039 0.333313 1.12346 0.333313Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12346 0.333313H11.2587C12.5679 0.333313 13.6293 1.38544 13.6293 2.68331V13.65C13.6293 14.9478 12.5679 16 11.2587 16H1.12346C0.687039 16 0.333252 15.6493 0.333252 15.2166V1.11665C0.333252 0.684023 0.687039 0.333313 1.12346 0.333313ZM6.74424 7.38331C7.61708 7.38331 8.32465 6.68189 8.32465 5.81665C8.32465 4.9514 7.61708 4.24998 6.74424 4.24998C5.8714 4.24998 5.16383 4.9514 5.16383 5.81665C5.16383 6.68189 5.8714 7.38331 6.74424 7.38331ZM3.26373 12.0833C3.15363 12.0833 2.93537 11.8185 2.94464 11.6913C3.1148 9.35463 4.81534 8.16665 6.88806 8.16665C8.98995 8.16665 10.7168 9.28936 10.8455 11.6916C10.8506 11.7873 10.8455 12.0833 10.5157 12.0833H3.26373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/Booking.79f1f70de704b6c03f8313756d7d12f5.svg";
export { ForwardRef as ReactComponent };